export const msalConfig = {
    auth: {
      clientId: "<YOUR_CLIENT_ID>",
      authority: "https://login.microsoftonline.com/<YOUR_TENANT_ID>",
      redirectUri: `${process.env.REACT_APP_API_URL}/auth/redirect`,
    },
  };
  
  export const loginRequest = {
    scopes: ["openid", "profile", "email"],
  };
  